import { render } from "./newtokenmodal.vue?vue&type=template&id=ead35adc"
import script from "./newtokenmodal.vue?vue&type=script&lang=js"
export * from "./newtokenmodal.vue?vue&type=script&lang=js"

import "./newtokenmodal.vue?vue&type=style&index=0&id=ead35adc&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__